import React from 'react';

import {Link} from 'react-router';

import {
  StyledCompactItemHeaderDiv,
  StyledCompactItemHeaderSpan,
} from 'app/general/bootstrap/utils';
import {DocumentIcon} from 'app/notifly/components/DocumentIconWithNotifications';
import {getObjectName} from 'app/utils/fallbacks';

import type {DocumentSerializedType} from 'sweet-types';

type FullProps = {
  object: DocumentSerializedType;
};

export const FullDocItem = ({object}: FullProps) => {
  return (
    <li className="list-group-item list-group-item-action flex-column align-items-start">
      <div
        className="row py-2 d-flex align-items-center"
        style={{
          position: 'relative',
        }}
      >
        <StyledCompactItemHeaderDiv className="flex-column">
          <Link
            to={object.html_url}
            className="text-dark font-weight-bold d-block d-flex w-100"
          >
            <StyledCompactItemHeaderSpan>
              <DocumentIcon
                className="mr-1"
                contentType={object.document_content_type}
              />

              {getObjectName(object, object.document_content_type, true)}
            </StyledCompactItemHeaderSpan>
          </Link>
        </StyledCompactItemHeaderDiv>
      </div>
    </li>
  );
};
